import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { RestrictionIcon } from '../../../sca/libraries/components/cell-content/restriction-icon'

interface BridgeProps {
  readonly restrictedByOrg: boolean
  readonly invalidVersion: boolean
  readonly versionRestriction?: number
  readonly restrictedLicense?: boolean
}

export const BridgeComponent = (props: BridgeProps) => {
  return <RestrictionIcon policies={props} />
}

export const libraryRestrictionIcon = createNgReactBridgeDirective(
  'reactLibraryRestrictionIcon',
  [],
  BridgeComponent,
  [
    'restrictedByOrg',
    'invalidVersion',
    'versionRestriction',
    'restrictedLicense'
  ]
)
